import api from '@/services/api';
import type {
    PlanVehicleRule,
    PlanVehicleRuleBatchPayload,
    PlanVehicleRuleBatchResult,
    PlanVehicleRulePayload,
} from '../types/planVehicleRule.types';

const smrPath = '/smr';

export const fetchPlanVehicleRules = async (planId: string): Promise<PlanVehicleRule[]> =>
    (await api.get(`${smrPath}/plans/${planId}/vehicle-rules`)).data.data ?? [];

export const createPlanVehicleRule = async (
    planId: string,
    payload: PlanVehicleRulePayload,
): Promise<PlanVehicleRule> =>
    (await api.post(`${smrPath}/plans/${planId}/vehicle-rules`, payload)).data.data;

export const updatePlanVehicleRule = async (
    planId: string,
    ruleId: string,
    payload: PlanVehicleRulePayload,
): Promise<PlanVehicleRule> =>
    (await api.put(`${smrPath}/plans/${planId}/vehicle-rules/${ruleId}`, payload)).data.data;

export const deletePlanVehicleRule = async (planId: string, ruleId: string): Promise<void> => {
    await api.delete(`${smrPath}/plans/${planId}/vehicle-rules/${ruleId}`);
};

export const createPlanVehicleRules = async (
    planId: string,
    payload: PlanVehicleRuleBatchPayload,
): Promise<PlanVehicleRuleBatchResult> =>
    (await api.post(`${smrPath}/plans/${planId}/vehicle-rules/batch`, payload)).data;
